import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12738efd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tournaments" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "center display-2" }, "Turneringer", -1))
const _hoisted_3 = { class: "layout gutter--xl" }
const _hoisted_4 = { class: "row justify--end" }
const _hoisted_5 = { class: "row justify--center tournamentContainer" }
const _hoisted_6 = { class: "flex md4 sm6 xs12 tournamentBox" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "display-4 center" }, "Hovedturneringen", -1))
const _hoisted_8 = { class: "flex md4 xs12 sm6 tournamentBox" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "display-4 center" }, "Hverdagsturneringen", -1))
const _hoisted_10 = { class: "flex md4 xs12 sm6 tournamentBox" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "display-4 center" }, "35+", -1))
const _hoisted_12 = { class: "flex md4 xs12 sm6 tournamentBox" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "display-4 center" }, "50+", -1))
const _hoisted_14 = { class: "flex md4 xs12 sm6 tournamentBox" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "display-4 center" }, "Damepairs", -1))
const _hoisted_16 = { class: "flex md4 xs12 sm6 tournamentBox" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "display-4 center" }, "Junior", -1))
const _hoisted_18 = { class: "flex md4 xs12 sm6 tournamentBox" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "display-4 center" }, "Paradart", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_select = _resolveComponent("va-select")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_va_select, {
          modelValue: _ctx.turneringerSeason,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.turneringerSeason) = $event)),
          class: "mb-3",
          options: _ctx.seasonOptions,
          "text-by": (option) => option.name,
          "track-by": (seasonOptions) => `${seasonOptions.startDate}-${seasonOptions.endDate}`,
          label: "Turneringer"
        }, null, 8, ["modelValue", "options", "text-by", "track-by"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainTournament, (item) => {
            return (_openBlock(), _createElementBlock("p", {
              key: item.id
            }, [
              _createVNode(_component_router_link, {
                to: { name: 'MatchSchedule', params: { tournamentSlug: _ctx.generateTournamentSlug(item.raekke_navn, _ctx.currentSeasonId, item.id) }}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.raekke_navn), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dailyTournament, (item) => {
            return (_openBlock(), _createElementBlock("p", {
              key: item.id
            }, [
              _createVNode(_component_router_link, {
                to: { name: 'MatchSchedule', params: { tournamentSlug: _ctx.generateTournamentSlug(item.raekke_navn, _ctx.currentSeasonId, item.id) }}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.raekke_navn), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.old35, (item) => {
            return (_openBlock(), _createElementBlock("p", {
              key: item.id
            }, [
              _createVNode(_component_router_link, {
                to: { name: 'MatchSchedule', params: { tournamentSlug: _ctx.generateTournamentSlug(item.raekke_navn, _ctx.currentSeasonId, item.id) }}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.raekke_navn), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.old50, (item) => {
            return (_openBlock(), _createElementBlock("p", {
              key: item.id
            }, [
              _createVNode(_component_router_link, {
                to: { name: 'MatchSchedule', params: { tournamentSlug: _ctx.generateTournamentSlug(item.raekke_navn, _ctx.currentSeasonId, item.id) }}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.raekke_navn), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.women, (item) => {
            return (_openBlock(), _createElementBlock("p", {
              key: item.id
            }, [
              _createVNode(_component_router_link, {
                to: { name: 'MatchSchedule', params: { tournamentSlug: _ctx.generateTournamentSlug(item.raekke_navn, _ctx.currentSeasonId, item.id) }}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.raekke_navn), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.junior, (item) => {
            return (_openBlock(), _createElementBlock("p", {
              key: item.id
            }, [
              _createVNode(_component_router_link, {
                to: { name: 'MatchSchedule', params: { tournamentSlug: _ctx.generateTournamentSlug(item.raekke_navn, _ctx.currentSeasonId, item.id) }}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.raekke_navn + (item.turneringskategori_id === _ctx.locDefaultJuniorTournamentSpringId ? ' (forår)' : '') + (item.turneringskategori_id === _ctx.locDefaultJuniorTournamentFallId ? ' (efterår)' : '')), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paradart, (item) => {
            return (_openBlock(), _createElementBlock("p", {
              key: item.id
            }, [
              _createVNode(_component_router_link, {
                to: { name: 'MatchSchedule', params: { tournamentSlug: _ctx.generateTournamentSlug(item.raekke_navn, _ctx.currentSeasonId, item.id) }}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.raekke_navn), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}